import {createReducer, on} from "@ngrx/store";
import {IMissionCreateState} from "./tech-mission-create.state";
import {SharedSolutionActions} from "@shared/components/solution/store/shared-solution.actions-type";
import {TechMissionCreateEffects} from "@tech/pages/inventory/pages/mission-create/store/tech-mission-create.effects";
import {TechMissionCreateActions} from "@tech/pages/inventory/pages/mission-create/store/tech-mission-create.actions-type";
import {cloneDeep} from "lodash";
import {MissionDto, StartingMissionDto} from "@server-models";

export const initialMissionCreateState: IMissionCreateState = <IMissionCreateState>{
  isLoading: false
};

export const techMissionCreateStore = createReducer(
  initialMissionCreateState,
  on(TechMissionCreateActions.getMission, (state) => ({
    ...state,
    isLoading: true
  })),
  on(TechMissionCreateActions.getMissionSuccess, (state, { model }) => ({
    ...state,
    mission: cloneDeep(model) as StartingMissionDto,
    origin: cloneDeep(model),
    isLoading: false,
  })),
  on(TechMissionCreateActions.getMissionFail, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(TechMissionCreateActions.postMission, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(TechMissionCreateActions.postMissionSuccess, (state, { model }) => ({
    ...state,
    mission: cloneDeep(model),
    origin: cloneDeep(model) as MissionDto,
    isLoading: false,
  })),
  on(TechMissionCreateActions.postMissionFail, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(TechMissionCreateActions.postFollowUpMission, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(TechMissionCreateActions.postFollowUpMissionSuccess, (state, { model }) => ({
    ...state,
    mission: cloneDeep(model),
    origin: cloneDeep(model) as MissionDto,
    isLoading: false,
  })),
  on(TechMissionCreateActions.postFollowUpMissionFail, (state) => ({
    ...state,
    isLoading: false,
  }))
);


